import { AxiosHelper } from "../axiosConfig";
import CannedTest from "../model/cannedTests/cannedTest";
import APIConstant from "../utils/apiConstant";
import { arrayToQueryParams } from "../utils/reusedFunctions";
import { ISubject } from "../model/interface/subject";

export const getCannedTestTypes = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_CANNED_TEST_TYPE_ALL, {
    params: {},
  });
};

export const getRecommendedStandards = (stateId, gradeId, subjectId) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_CANNED_RECOMMENDED_STANDARDS}?${arrayToQueryParams(
      stateId,
      "stateId"
    )}&&${arrayToQueryParams(gradeId, "gradeId")}&&subjectId=${subjectId}`
  );
};

export const getCannedTests = (
  stateId: number,
  gradeId: number,
  cannedTestTypeId: number,
  isActive: boolean | undefined,
  isApproved: boolean,
  pageNumber: number,
  pageSize: number,
  orderByColumn: string,
  sortDir: string,
  cannedTestId: number,
  subjectId?: number,
  contentAreaId?: number,
  name?: string,
  requiresSubscription?: boolean
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_CANNED_TESTS, {
    params: {
      stateId: stateId,
      gradeId: gradeId,
      cannedTestTypeId: cannedTestTypeId,
      isActive: isActive,
      isApproved: isApproved,
      pageNumber: pageNumber,
      pageSize: pageSize,
      orderByColumn: orderByColumn,
      sortDir: sortDir,
      cannedTestId: cannedTestId,
      ...(subjectId != null && { subjectId: subjectId }),
      ...(contentAreaId != null && { contentAreaId: contentAreaId }),
      ...(name != null && { name: name }),
      ...(requiresSubscription === true && { requiresSubscription: true }),
    },
  });
};

export const saveCannedTest = (params) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_CANNED_TEST,
    params,
    {}
  );
};

export const getCannedTest = (cannedTestId: number) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_CANNED_TEST + `/${cannedTestId}`
  );
};

export const getQuestionsCopyCannedTest = (
  cannedTestId: number,
  subjectId: number
) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_COPYQUESTIONS_TEST +
      `?cannedtestId=${cannedTestId}&subjectId=${subjectId}`
  );
};

export const isQuestionValid = (
  stateId: Array<number>,
  gradeId: Array<number>,
  subjectId: number,
  questionId: number,
  domainId?: number
) => {
  return AxiosHelper.axiosInstance().get(
    `${
      APIConstant.CMS_CANNED_TEST_IS_QUESTION_VALID
    }?subjectId=${subjectId}&&questionId=${questionId}&&domainId=${domainId}&&${arrayToQueryParams(
      stateId,
      "stateId"
    )}&&${arrayToQueryParams(gradeId, "gradeId")}`
  );
};

export const importFile = (params) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_CANNED_TEST_Import_File,
    params,
    {}
  );
};

export const copyCannedTest = (
  cannedTestId: number,
  targetStateIds: Array<number>,
  userId: number
) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_CANNED_TEST_COPY,
    {
      cannedTestId: cannedTestId,
      targetStateIds: targetStateIds,
      userId: userId,
    },
    {}
  );
};

export const deleteCannedTest = (id: number) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_CANNED_TEST, {
    params: {
      id: id,
    },
  });
};

export const deleteCannedTestSection = (id: number) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_CANNED_TEST_SECTION,
    {
      params: {
        id: id,
      },
    }
  );
};

export const deleteCannedTestSectionGroup = (id: number) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_CANNED_TEST_SECTION_GROUP,
    {
      params: {
        id: id,
      },
    }
  );
};

export const getQuestions = (stateId, gradeId, subjectId) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_CANNED_SEARCH_QUESTIONS}?${arrayToQueryParams(
      stateId,
      "stateId"
    )}&&${arrayToQueryParams(gradeId, "gradeId")}&&subjectId=${subjectId}`
  );
};

export const getSubjects = () => {
  return AxiosHelper.axiosInstance().get<Array<ISubject>>(
    APIConstant.CMS_CANNED_TESTS_GET_SUBJECTS
  );
};
